import type { Navigation } from '~/types/api/navigation'
import { productionMainMenuLinks, developmentMainMenuLinks } from '~/configFiles/menuLinksMainMenu' // pragma: allowlist secret

function getFirstNavigableRoute(links: Navigation[]): string | undefined {
    for (const link of links) {
        if (link.to?.trim()) {
            return link.to
        }
        if (link.subItems?.length) {
            const subRoute = getFirstNavigableRoute(link.subItems)
            if (subRoute) {
                return subRoute
            }
        }
    }
    return undefined
}

interface UserInfo {
    email: string
    username: string
    usertype: string[]
    id: number
}

export default defineNuxtRouteMiddleware((to) => {
    const config = useRuntimeConfig()
    const seoSelectedDomain = useState('seoSelectedDomain', () => null)
    const webformsSelectedDomain = useState('webformsSelectedDomain', () => null)
    const jsessionid = useCookie('JSESSIONID')

    if (to.path == '/dashboard' && jsessionid.value && !to.query?.redirect_uri) {
        const userinfo = useCookie<UserInfo>('USERINFO')
        const roles = userinfo.value?.usertype || []
        const menuLinks = config.public.isDevelopment
            ? developmentMainMenuLinks('', '', roles)
            : productionMainMenuLinks('', '', roles) // pragma: allowlist secret

        const firstRoute = getFirstNavigableRoute(menuLinks) ?? '/dashboard/seo'

        if (firstRoute !== '/dashboard') {
            console.log('dashboard-redirect.global: Redirecting to first menu route', firstRoute)
            return navigateTo(firstRoute)
        }
    }

    if (to.path == '/dashboard/seo' && seoSelectedDomain.value) {
        console.log('dashboard-redirect.global: Redirecting to dashboard/seo/{domain}/overview. domain is selected', seoSelectedDomain.value)
        return navigateTo(`/dashboard/seo/${seoSelectedDomain.value}/overview`, { replace: true })
    }

    if (to.path == '/dashboard/webforms' && webformsSelectedDomain.value) {
        return navigateTo(`/dashboard/webforms/${webformsSelectedDomain.value}/overview`, { replace: true })
    }
})
